import React from "react";
import { Outlet } from "react-router-dom";
import "./dashboard.css";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";

const Dashboard = () => {
  return (
    <div className="dashboard">
      <Header />
      <div className="dashboard-body">
        <Sidebar />
        <main className="main-content">
          <Outlet />
         {/* <Footer /> */}
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
